import { 
    CREATE_STRIPECUSTOMER_STARTED,CREATE_STRIPECUSTOMER_SUCESS,CREATE_STRIPECUSTOMER_FAILED,
    CREATE_SUBCRIPTION_STARTED,CREATE_SUBCRIPTION_SUCESS,CREATE_SUBCRIPTION_FAILED,
    GETALL_SUBCRIPTION_STARTED,GETALL_SUBCRIPTION_SUCESS,GETALL_SUBCRIPTION_FAILED,
    
    CREATE_FREQUENCY_STARTED,CREATE_FREQUENCY_SUCESS,CREATE_FREQUENCY_FAILED,
    GETALL_FREQUENCY_STARTED,GETALL_FREQUENCY_SUCESS,GETALL_FREQUENCY_FAILED,
    CREATE_COMPANY_DISCOUNT_STARTED,CREATE_COMPANY_DISCOUNT_SUCESS,CREATE_COMPANY_DISCOUNT_FAILED,


    
 } from '../actions/StripePayment';

 const intialData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {       
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};
export const stripeCustomerData = (state = intialData, action: any) => {
  
 
    switch (action.type) {
        case CREATE_STRIPECUSTOMER_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case CREATE_STRIPECUSTOMER_SUCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case CREATE_STRIPECUSTOMER_FAILED:
      return {
        ...state,
        isLoading: true,
      };
      default:
        return state;
    }
    
    }

    export const subcriptionData = (state = intialData, action: any) => {

      switch (action.type) {
        
        case CREATE_SUBCRIPTION_STARTED:           
        return {
          ...state,
          items:[],
          isLoading: true,
        };
        case CREATE_SUBCRIPTION_SUCESS:
          return {
            ...state,
            isLoading: false,
            status: action.status,
            items: action.payload
          };
        case CREATE_SUBCRIPTION_FAILED:
          return {
            ...state,
            isLoading: true,
          };
          case GETALL_SUBCRIPTION_STARTED:  
          return {
            ...state,
            items:[],
            isLoading: true,
          };
        case GETALL_SUBCRIPTION_SUCESS:
          return {
            ...state,
            isLoading: false,
            status: action.status,
            items: action.payload
          };
        case GETALL_SUBCRIPTION_FAILED:
          return {
            ...state,
            isLoading: true,
          };
          default:
            return state;
      }
    }
 
    export const frequencyData = (state = intialData, action: any) => {

      switch (action.type) {
        
        case CREATE_FREQUENCY_STARTED:           
        return {
          ...state,
          items:[],
          isLoading: true,
        };
        case CREATE_FREQUENCY_SUCESS:
          return {
            ...state,
            isLoading: false,
            status: action.status,
            items: action.payload
          };
        case CREATE_FREQUENCY_FAILED:
          return {
            ...state,
            isLoading: true,
          };
          case GETALL_FREQUENCY_STARTED:  
          return {
            ...state,
            items:[],
            isLoading: true,
          };
        case GETALL_FREQUENCY_SUCESS:
          return {
            ...state,
            isLoading: false,
            status: action.status,
            items: action.payload
          };
        case GETALL_FREQUENCY_FAILED:
          return {
            ...state,
            isLoading: true,
          };
          default:
            return state;
      }
    }

    export const companyDiscountData = (state = intialData, action: any) => {

      switch (action.type) {
        
        case CREATE_COMPANY_DISCOUNT_STARTED:           
        return {
          ...state,
          items:[],
          isLoading: true,
        };
        case CREATE_COMPANY_DISCOUNT_SUCESS:
          return {
            ...state,
            isLoading: false,
            status: action.status,
            items: action.payload
          };
        case CREATE_COMPANY_DISCOUNT_FAILED:
          return {
            ...state,
            isLoading: true,
          };
         
          default:
            return state;
      }
    }